"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class CustomerClient extends BaseApiClient_1.BaseApiClient {
    async registerWarehouse(registerWarehouse) {
        const path = `/customers/warehouseupdater`;
        return await this.request('put', path, undefined, registerWarehouse);
    }
    async deregisterWarehouse(oc1orgkey, oc1customerid, sc1tplguid, sc1warehouseid) {
        const path = `/customers/warehouseupdater/org/${oc1orgkey}/cust/${oc1customerid}/tplguid/${sc1tplguid}/ware/${sc1warehouseid}`;
        return await this.request('delete', path, undefined, undefined);
    }
}
exports.CustomerClient = CustomerClient;
